// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error__fullscreen[data-v-307a655c] {\n  left: 0;\n  position: fixed;\n  top: 0;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  padding: 100px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
